import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import Switch from "react-bootstrap-switch";
import {useSelector} from "react-redux";


import {getStateByPath} from "../../../../redux/selectors";

const NonRecurringPromotion = ({udn, onChangeData, path}) => {
    const componentState = useSelector(state => getStateByPath(state, path));

    const { domainObject } = componentState?.data || {};
    const {schedules = []} = domainObject || {}

    const schedule = schedules[0]

    const [hourStart, setHourStart] = useState(schedule?.hourStart || udn?.openingTime)
    const [hourEnd, setHourEnd] = useState(schedule?.hourEnd || udn?.closingTime)
    const [hasError, setHasError] = useState(schedule?.hasError ||  false);
    const [errorMessage, setErrorMessage] = useState(schedule?.errorMessage || '');
    const [date, setDate] = useState(schedule?.startDate ? schedule?.startDate.split('T')[0] : new Date().toISOString().split('T')[0]);
    const [dayOfWeek, setDayOfWeek] = useState(schedule?.dayOfWeek || (new Date().getDay() === 0 ? 7 : new Date().getDay()) );

    const [onlyToDay, setOnlyToDay] = useState(domainObject?.applyOnlyToCreationDate === null ? true : domainObject?.applyOnlyToCreationDate )
    const [isFullDay, setIsFullDay] = useState(domainObject?.isFullDay ||false)


    const [data, setData] = useState({
        id: schedule?.id || null,
        startDate : date,
        endDate: date,
        hourStart: isFullDay ? udn?.openingTime : hourStart,
        hourEnd: isFullDay ? udn?.closingTime : hourEnd,
        dayOfWeek,
    });



    useEffect(() => {
        let initialData = {
            startDate : date,
            endDate: date,
            hourStart: isFullDay ? udn?.openingTime : hourStart,
            hourEnd: isFullDay ? udn?.closingTime : hourEnd,
            dayOfWeek,
        }

        if(schedule)
            initialData = { ...initialData, id: schedule?.id }

        setData(initialData)
        onChangeData('SCHEDULE', [initialData])
    }, [schedule]);



    const onChangeIsFullDate = ({state:{value}}) => {
        setIsFullDay(value)
        onChangeData('IS_FULL_DAY', value)

        if(!value)
            return

        setHourStart(udn?.openingTime)
        setHourEnd(udn?.closingTime)


        const newData = {
            ...data,
            hourStart: udn?.openingTime,
            hourEnd: udn?.closingTime,
            hasError: false,
            errorMessage: '',
            dayOfWeek,
        }

        setHasError(false)
        setErrorMessage('')
        setData(newData)
        onChangeData('SCHEDULE', [newData])
    }


    const onChangeOnlyToDay = ({state:{value}}) => {
        setOnlyToDay(value)
        onChangeData('APPLY_ONLY_TO_CREATION_DATE', value)
    }


    const onOpeningTimeChange = ({ target:{ value } }) => {
        setHourStart(value)
        let hasError = true

        if(!value){
            setHasError(true)
            setErrorMessage('Debe seleccionar una hora en que inicia la promoción')
            onSetData('hourStart', value, hasError)

            return
        }

        if(!hourEnd){
            setHasError(true)
            setErrorMessage('Debe seleccionar la hora en que finaliza la promoción')
        } else if (value > hourEnd) {
            setHasError(true)
            setErrorMessage('La hora de fin de la promoción debe ser mayor a la de inicio')
        } else {
            hasError = false
            setHasError(false)
            setErrorMessage('')
        }

        onSetData('hourStart', value, hasError)
    }

    const onClosingTimeChange = ({target:{ value }}) => {
        setHourEnd(value)
        let hasError = true

        if(!value){
            setHasError(true)
            setErrorMessage('Debe seleccionar la hora en que finaliza la promoción')
            onSetData('hourEnd', value, hasError)

            return
        }

        if(!hourStart){
            setHasError(true)
            setErrorMessage('Debe seleccionar una hora de en que inicia la promoción')
        } else if (value < hourStart) {
            setHasError(true)
            setErrorMessage('La hora de fin de la promoción debe ser mayor a la de inicio')
        } else {
            hasError = false
            setHasError(false)
            setErrorMessage('')
        }

        onSetData('hourEnd', value, hasError)
    }


    const onDateChange = ({target:{value}}) => {
        setDate(value)
        let hasError = false

        if(!value) {
            setHasError(true)
            setErrorMessage('Debe seleccionar una fecha valida')
            hasError = true
        } else if(!hourStart || !hourEnd) {
            setHasError(true)
            setErrorMessage('Debe seleccionar una hora de inicio y fin de la promoción')
            hasError = true
        } else if(hourEnd < hourStart) {
            setHasError(true)
            setErrorMessage('La hora de fin de la promoción debe ser mayor a la de inicio')
            hasError = true
        } else {
            setHasError(false)
            setErrorMessage('')
        }

        const fecha = new Date(`${value}T00:00:00`)
        const diaSemana = fecha.getDay()

        const newData = {
            ...data,
            startDate: value,
            endDate: value,
            hasError,
            dayOfWeek: diaSemana,
        }

        setData(newData)
        setDayOfWeek(diaSemana)

        onChangeData('SCHEDULE', [newData])
    }


    const onSetData = (key, value, hasError) => {
        if(!key) return;


        const newData = {
            ...data,
            [key]: value,
            hasError,
            errorMessage,
            dayOfWeek,
        }

        setData(newData)

        onChangeData('SCHEDULE', [newData])
    }



    return <>
        <FormGroup row>
            <Label sm={6}>
                ¿La promoción aplica solo para el día de hoy?
            </Label>
            <Col className={'pull-right'}>
                <Switch
                    animate={true}
                    onText={"Si"}
                    offText={"No"}
                    value={onlyToDay}
                    onChange={onChangeOnlyToDay}
                />
            </Col>
        </FormGroup>

        <div className={'schedule-container'}>
            {
                !onlyToDay && <FormGroup row>
                    <Label sm={6}>
                        ¿Que fecha sera valida la proción?
                    </Label>
                    <Col>
                        <Input
                            type = { 'date' }
                            value={ date }
                            min = { new Date().toISOString().split('T')[0] }
                            onChange={ onDateChange }
                        />
                    </Col>
                </FormGroup>
            }

            <Row>
                <Col>
                    <FormGroup>
                        <Label> ¿La promoción es valida todo el día? </Label>
                        <br/>
                        <Switch
                            animate={true}
                            onText={"Si"}
                            offText={"No"}
                            value={isFullDay}
                            onChange={onChangeIsFullDate}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <Row className={"mb-2em"}>
                        <Col md={6}>
                            <label className={"mr-1em"}>Hora de inicio:</label>
                            <Input
                                type={"time"}
                                className={"form-control d-inline-block w-auto"}
                                value={ hourStart }
                                onChange={ onOpeningTimeChange }
                                readOnly={ isFullDay }
                            />
                        </Col>
                        <Col md={6}>
                            <label className={"mr-1em"}>Hora de fin:</label>
                            <Input
                                type={"time"}
                                className={"form-control d-inline-block w-auto"}
                                value={ hourEnd }
                                onChange={ onClosingTimeChange }
                                readOnly={ isFullDay } />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {
                hasError && <div className={'text-danger schedule-danger'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"/>
                    <div className={"alert alert-danger schedule-error-message"}>{errorMessage}</div>
                </div>
            }
        </div>

    </>
}



NonRecurringPromotion.propTypes = {
    udn: PropTypes.object.isRequired,
    onChangeData: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
};

export default NonRecurringPromotion;